/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import StripeKeyEvent from '../../event/StripeKeyEvent'
import { StripeKeyState } from '../state/StripeKeyState'

class StripeKeysStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case StripeKeyEvent.onSearch:
        if (!payload || !payload.stripe_api_keys) {
          return state
        }

        const stripe_api_keys = payload.stripe_api_keys.map(stripe_key => new StripeKeyState(stripe_key))
        return List(stripe_api_keys)
      default:
        return state
    }
  }
}

export default new StripeKeysStore()
